import type { UIEvent } from 'react';

export function composeEvents<E extends UIEvent, Args extends [], Return>(
  preventDefault: boolean,
  ...fns: (undefined | ((event: E, ...args: Args) => Return))[]
) {
  return (event: E, ...args: Args) => {
    if (preventDefault) {
      event.preventDefault();
    }
    fns.forEach((fn) => fn && fn(event, ...args));
  };
}
